/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_Galicia_Faq_A6Inputs */

const es_marketplace_seo_galicia_faq_a6 = /** @type {(inputs: Marketplace_Seo_Galicia_Faq_A6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí. La mayoría de experiencias turísticas y muchos alquileres ofrecen patrón opcional u obligatorio. Filtra por «con patrón» para ver solo embarcaciones tripuladas.`)
};

const gl_marketplace_seo_galicia_faq_a6 = /** @type {(inputs: Marketplace_Seo_Galicia_Faq_A6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si. A maioría de experiencias turísticas e moitos alugueiros ofrecen patrón opcional ou obrigatorio. Filtra por «con patrón» para ver só embarcacións tripuladas.`)
};

const en_marketplace_seo_galicia_faq_a6 = /** @type {(inputs: Marketplace_Seo_Galicia_Faq_A6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Most tourist experiences and many rentals offer optional or mandatory skipper. Filter by «with skipper» to see crewed boats only.`)
};

/**
* | output |
* | --- |
* | "Yes. Most tourist experiences and many rentals offer optional or mandatory skipper. Filter by «with skipper» to see crewed boats only." |
*
* @param {Marketplace_Seo_Galicia_Faq_A6Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_galicia_faq_a6 = /** @type {((inputs?: Marketplace_Seo_Galicia_Faq_A6Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_Galicia_Faq_A6Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_galicia_faq_a6(inputs)
	if (locale === "en") return en_marketplace_seo_galicia_faq_a6(inputs)
	return es_marketplace_seo_galicia_faq_a6(inputs)
});